import { render } from "./CPostElements.vue?vue&type=template&id=05173e12"
import script from "./CPostElements.vue?vue&type=script&lang=js"
export * from "./CPostElements.vue?vue&type=script&lang=js"

import exportComponent from "/Users/tung/Documents/GitHub/cc-faq/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__